import QS from 'qs';
import { fetch } from '../utils/fetch';



/**
 * 列表
 * @returns {Promise<Response>}
 */
export function _listMbr(data) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/mbr`,
    method: 'get',
    params: data
  });
}
